import { computed as u } from "vue";
function s(r, t, n, e) {
  return u({
    get: () => {
      r.node.attrs[t] === "undefined" && console.error(
        `ERROR: Trying to access a node attribute [${t}] that does not exist`
      );
      const o = () => {
        try {
          return e == null ? void 0 : e(r.node.attrs);
        } catch (d) {
          console.error(
            `[useAttrModel] Error in fallback function: ${d.message}`
          );
          return;
        }
      };
      return r.node.attrs[t] ?? o();
    },
    set: (o) => {
      r.updateAttributes({ [t]: o }), n == null || n(o);
    }
  });
}
export {
  s as useAttrModel
};
